import React from 'react'

const Shape = () => (
  <svg viewBox="0 0 172 173" xmlnsXlink="http://www.w3.org/1999/xlink">
    <circle fill="#DC0A0A" cx="86" cy="86.5" r="86" />
  </svg>
)

export default Shape
